<template>
  <tr>
    <td>
      {{ name }}
    </td>
    <td>
      <span class="text-primary cursor--pointer" @click="show">
        <i class="fa fa-info-circle"></i> {{ articleName }}
      </span>
    </td>
    <td class="text-right">{{ $filters.formatMoney(pricePerUnit) }}</td>
    <td>
      <span v-if="configuration.is_logo_print">
        <span v-if="configuration.file"
          class="text-primary cursor--pointer"
          @click="download">
          <i class="fa fa-download"></i> {{ configuration.file.original_name }}
        </span>
        <span v-else>
          <i class="mr-1">{{ $t('configurator.labels.upload_missing') }}</i>
        </span>
      </span>
      <span v-else>
        {{ configuration.label }}
      </span>
    </td>
    <td>
      <span 
        class="text-primary cursor--pointer"
        @click="remove">
        <i class="fa fa-trash"></i> {{ $t('configurator.buttons.remove_from_basket') }}
      </span>
    </td>
  </tr>
</template>

<script setup>
import { computed } from 'vue'
import { useMainStore } from '@/store'
import { addLateDeliverySurcharge } from '@/utils/helper'

const store = useMainStore()
// define props
const props = defineProps({
  configuration: {
    type: Object,
    required: true
  }
})
// define emits
const emit = defineEmits(['download', 'show', 'remove'])
// define computed props
const locale = computed(() => store.settings.locale)
const boothArticles = computed(() => store.tmp.booth_articles)
const earlyBirdMode = computed(() => store.tmp.early_bird_mode)
const lateDelivery = computed(() => store.tmp.late_delivery)

const inEnglish = computed(() => {
  return locale.value === 'en'
})

const name = computed(() => {
  return (inEnglish.value)
    ? props.configuration.booth_refinement.name_en
    : props.configuration.booth_refinement.name
})

const article = computed(() => {
  const index = boothArticles.value.findIndex((boothArticle) => {
    return boothArticle.id === props.configuration.article_id
  })

  if (index > -1) {
    return boothArticles.value[index]
  }

  return null
})

const articleName = computed(() => {
  if (article.value) {
    return (inEnglish.value)
      ? article.value.name_en
      : article.value.name
  }
})

const exhibitionPrices = computed(() => {
  if (article.value) {
    return JSON.parse(article.value.pivot.prices)
  }

  return { price_net: 0 }
})

const pricePerUnit = computed(() => {
  return (earlyBirdMode.value)
    ? addLateDeliverySurcharge(exhibitionPrices.value.price_net, lateDelivery.value)
    : exhibitionPrices.value.price_net
})
// define methods
const show = () => {
  emit('show', article.value)
}

const remove = () => {
  emit('remove', props.configuration)
}

const download = () => {
  emit('download', props.configuration.file)
}
</script>